import { Link } from "react-router-dom";
import { DetailsList, FontSizes, FontWeights, PrimaryButton, SelectionMode, Stack } from "@fluentui/react";
import * as React from "react";
import { useEffect, useState } from "react";
import { netGrossColumn, netGrossField, netGrossFieldName } from "../../../Utilities/NetGrossField";
import { MoneyFormat } from "../../../Utilities/MoneyFormat";

function ChildrenAgreements({ items, netGross, agreement }) {

    const [columns, setColumns] = useState([]);
    useEffect(() => {
        setColumns([
            {
                key: 'venture_name',
                name: 'Kontrakt',
                ariaLabel: 'Kontrakt',
                fieldName: 'venture_name',
                isResizable: true,
                isSorted: true,
                minWidth: 250,
                onRender: (item) => (<Link to={`/venture/${item.venture_id}/cost`}><PrimaryButton text={item.venture_name} /></Link>)
            },
            {
                key: 'name',
                name: 'Nazwa',
                ariaLabel: 'Nazwa',
                fieldName: 'name',
                isResizable: true,
                isSorted: false,
                minWidth: 150,
            },
            {
                ...netGrossColumn()
            },
        ]);
    }, [netGross]);

    const sum = (subCosts) => {
        let total = 0;
        for (const item of subCosts) {
            total += parseFloat(item[netGrossField()]);
        }
        return MoneyFormat(total);
    };

    return <Stack.Item grow={true}>
        <h4 style={{ fontSize: FontSizes.size24, fontWeight: FontWeights.light }}>Koszty powiązane</h4>
        <h4>{sum(items)} / {MoneyFormat(agreement[netGrossField()])}</h4>
        <DetailsList items={items} columns={columns} selectionMode={SelectionMode.none} />
    </Stack.Item>;
}

export default ChildrenAgreements;